import { Form, Formik } from 'formik';
import { SolicitudUnicaForm } from './SolicitudIndividualForm';
import { SchemaIndividual } from './SchemaIndividual';
import { AlertaError, AlertaExito } from 'utils/Alertas';
import Heading from 'components/design-system/Heading/Heading';
import gruposService from 'services/grupos';

export const SolicitudUnica = () => {
  return (
    <div className="bg-white rounded p-5 shadow-md mb-5">
      <Heading type="h4" className="mb-4">
        Enviar solicitud a un negocio registrado
      </Heading>
      <Formik
        initialValues={{
          rol: null,
          negocio: null,
          sucursalesSeleccionadas: []
        }}
        validationSchema={SchemaIndividual}
        validateOnMount={true}
        onSubmit={async (values, { resetForm }) => {
          try {
            const params = {
              sucursales: values.sucursalesSeleccionadas.map(
                item => item.codigoSucursal
              ),
              grupo: null,
              correosElectronicos: null
            };
            await gruposService.solicitarAdministracion(params).then(res => {
              if (res.status === 200 && !res.data.error) {
                AlertaExito('La solicitud ha sido enviada correctamente');
              }
            });
          } catch (error) {
            AlertaError('Ha ocurrido un error en el envío de la solicitud');
          } finally {
            resetForm();
          }
        }}
      >
        {({
          values,
          touched,
          errors,
          isSubmitting,
          setFieldValue,
          setFieldTouched,
          handleChange,
          handleBlur
        }) => (
          <Form id="solicitud-individual" onChange={event => {}}>
            <SolicitudUnicaForm
              isSubmitting={isSubmitting}
              setFieldValue={setFieldValue}
              values={values}
              setFieldTouched={setFieldTouched}
              errors={errors}
              touched={touched}
              handleBlur={handleBlur}
              handleChange={handleChange}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};
